<template>
    <div>
        <b-dropdown slot="prepend" text="Åtgärd" variant="primary" title="Åtgärd" size="sm">
            <b-dropdown-item v-for="n in actions" :key="n.id" v-on:click="n.onclick" :title="n.description">
                {{ n.name }}
            </b-dropdown-item>
        </b-dropdown>
        <!-- Register New Event -->
        <b-modal title="Ny händelse" v-model="sNewEvent" ok-title="Registrera" cancel-title="Avbryt" @ok="RegNewEvent">
            <div v-if="!ids && !colliids">Något gick fel. Finns ingen bokning att registrera händelsen på.</div>
            <b-card>
                <b-card-title>
                    Registrera händelse för<span v-if="ids && ids.length > 0"> {{ ids.length }} bokningar</span>
                    <span v-if="colliids && colliids.length > 0"> {{ colliids.length }} kollin</span>.
                </b-card-title>
                <b-card-body v-if="ids && ids.length > 0">
                    <b-row>
                        <b-col><label>Händelsetyp:</label></b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="4">
                            <b-form-select class="form-control" v-model="newEvent.EventTypeId" :options="GetEventTypes()">
                            </b-form-select>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col><label>Tid:</label></b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="4">
                            <!-- <datepicker v-model="newEvent.RegDate" :stepper="true"></datepicker> -->
                            <datetimepicker :editMode="true" v-model="newEvent.RegDate"></datetimepicker>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col><label>Kommentar:</label></b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <b-input type="text" v-model="newEvent.Comment"></b-input>
                        </b-col>
                    </b-row>
                </b-card-body>
            </b-card>

        </b-modal>
        <!-- Release -->
        <b-modal title="Frisläpp" v-model="sRelease" ok-title="Frisläpp" cancel-title="Avbryt" @ok="Release">
            <div v-if="!ids">Något gick fel. Finns ingen bokning att registrera händelsen på.</div>
            <b-card>
                <b-card-title>
                    Frisläpp <span v-if="ids && ids.length > 0"> {{ ids.length }} bokningar</span>
                </b-card-title>
                <b-card-body>
                    Bokningarna kommer att skickas på det sätt som är definierat för respektive transportör.
                    Kommunikationen sker i bakgrunden och kommer att uföras inom någon/några minuter.
                    <b-alert show variant="warning" dismissible v-for="(e, i) in releaseErrs" :key="i">
                        {{ e }}
                    </b-alert>
                </b-card-body>
            </b-card>
        </b-modal>
        <b-modal title="Fraktdokument" v-model="sFreightDocs" ok-only ok-title="Stäng" size="xl">
            <a :href="currFreightDoc">Länk till dokument</a>&nbsp;<clipboardbutton :value="currFreightDocFullPath">
            </clipboardbutton>
            <b-embed type="iframe" aspect="16by9" :src="currFreightDoc" allowfullscreen></b-embed>
            <!-- <iframe :src="currFreightDoc"></iframe> -->
        </b-modal>
        <b-modal title="Omräkning" v-model="sRecalc" ok-title="Räkna om" cancel-title="Avbryt" @ok="Recalc">
            <div v-if="!ids">Något gick fel. Finns ingen bokning att räkna om.</div>
            <b-card>
                <b-card-title>
                    Räkna om <span v-if="ids && ids.length > 0"> {{ ids.length }} bokningar</span>
                </b-card-title>
                <b-card-body>

                    <b-form-group label="Räkna om:" v-slot="{ ariaDescribedby }">
                        <b-form-checkbox v-model="recalcOptions.sla">SLA</b-form-checkbox>
                        <b-form-checkbox v-model="recalcOptions.kpi">KPI:er</b-form-checkbox>
                        <b-form-checkbox v-model="recalcOptions.price">Pris</b-form-checkbox>
                    </b-form-group>
                </b-card-body>
            </b-card>
        </b-modal>
        <b-modal v-model="sProcess" ok-only>
            <b-progress v-if="maxvalue" :value="progress" :max="maxvalue" show-progress animated></b-progress>
            <label>{{ processText }}</label>
            <!-- <b-card>
                <b-card-body>
                    <b-row v-for="(p,i) in processQueue">
                        <b-col>{{i:}}{{ p.res }}</b-col>
                    </b-row>                    
                    
                </b-card-body>
            </b-card> -->
        </b-modal>
    </div>
</template>
<script>
import datetimepicker from '@/components/datetimepicker.vue';
import clipboardbutton from "./../../components/clipboardbutton.vue";

// import { Settings } from "../../lib/settings";
// const sett = new Settings();
import Settings from "../../lib/settings";

import { Api } from "../../lib/api";
const api = new Api();

export default {
    components: { datetimepicker, clipboardbutton },
    name: 'bookingactionbutton',
    props: {
        ids: {
            type: Array,
        },
        colliids: {
            type: Array
        }
    },
    data() {
        return {
            progress: null,
            maxvalue: null,
            actions: [
                {
                    name: 'Ny händelse',
                    description: 'Skapa ny händelse',
                    onclick: () => {
                        this.sNewEvent = true;
                        this.newEvent = { RegDate: new Date() }
                        if (!this.eventTypes)
                            api.get('/api/booking/GetEventTypes').then((res) => {
                                this.eventTypes = res.data;
                                this.newEvent.EventTypeId = this.eventTypes[0].EventTypeId;
                            });
                    }
                },
                // {
                //     name: 'Byt transportprodukt',
                //     description: 'Välj ny transportprodukt för bokningen',
                //     onclick: () => {
                //         alert('Ej implementerat');
                //     }
                // },
                {
                    name: 'Räkna om',
                    description: 'Räkna om värden som rör bokningen.',
                    onclick: () => {
                        this.sRecalc = true;
                    }
                },
                {
                    name: 'Frisläpp',
                    description: 'Stäng bokningen och skicka iväg den till vald transportör.',
                    onclick: () => { this.releaseErrs = []; this.sRelease = true; }
                },
                {
                    name: 'Skriv ut fraktsedlar',
                    description: 'Skriv ut fraktsedlar för bokningarna',
                    onclick: () => {
                        this.PrintFreightDocs();
                    }
                }
            ],
            sNewEvent: false,
            eventTypes: null,
            newEvent: {},
            recalcOptions: {
                sla: true,
                kpi: true,
                price: true,
            },
            sRecalc: false,
            sRelease: false,
            releaseInProgess: false,
            releaseErrs: [],
            sFreightDocs: false,
            currFreightDoc: null,
            currFreightDocFullPath: null,
            processQueue: [],
            processText:null,
            inProgress: false,
            sProcess:false,
        }
    },
    methods: {
        GetEventTypes() {
            return (!this.eventTypes) ? [] :
                this.eventTypes
                    .map(x => { return { "value": x.EventTypeId, "text": x.EventTypeName } })
                    .sort((a, b) => a.text.localeCompare(b.text));

        },
        RegNewEvent(ev) {
            //Validate
            ev.preventDefault(); //Always. Close via sNewEvent instead
            let ne = this.newEvent;
            if (!ne.EventTypeId || ne.EventTypeId == 0) {
                alert('Händelsetyp måste anges');

                return;
            }
            console.log(ne);

            var p = { ev: ne, ids: this.ids, colliids: this.colliids };

            api.post('/api/booking/RegisterNewEvent', p).then((res) => {
                if (res.data) {
                    alert(res.data);
                    return;
                }
                this.sNewEvent = false;
                this.OnAfterActionReady();
            });
        },
        Release(ev) {
            ev.preventDefault();
            if (this.releaseInProgess) {
                alert('En release pågår redan. Avvakta...');
                return;
            }
            if (this.ids.length == 0) {
                alert('Inga bokningar är markerade.');
                return;
            }

            var p = this.ids;
            api.post('/api/booking/release', p).then((res) => {
                this.releaseErrs = res.data;
                this.releaseInProgess = false;
                if (this.releaseErrs.length == 0)
                    this.sRelease = false;

                this.OnAfterActionReady();
            });
        },
        Recalc() {
            //Kolla om progress
            if (this.getUnProcessedQueue().length > 0) {
                alert('Process pågår redan');
                return;
            }
            this.processQueue = [];
            this.ids.map((x) => {
                let qp = {
                    id: x, fnc: (o) => {
                        var p = JSON.parse(JSON.stringify(this.recalcOptions));
                        p.bookingIds = [o.id];
                        api.post('/api/booking/recalc', p).then(res => {
                            o.res = res.data;
                            o.processed = true;
                            this.ProcessNext();
                        });
                    }
                };
                this.processQueue.push(qp);
            });   
            this.ProcessNext();    
        },
        //TODO: Lägg i egen komponent, hantera resultat
        ProcessNext() {
            let q = this.getUnProcessedQueue();
            this.progress = this.processQueue.length-q.length;
            this.maxvalue = this.processQueue.length;
               
            if (q.length > 0) {
                this.sProcess = true;
                this.inProgress = true;
                this.processText = `Processar ${this.progress} av ${this.maxvalue}...`;
                q[0].fnc(q[0]);
            } else {
                this.inProgress = false;
                this.processText = 'Klar!';
                this.progress = this.maxvalue;
                this.OnAfterActionReady();
            }
            
        },
        getUnProcessedQueue() {
            if (this.processQueue && this.processQueue.length > 0)
                return this.processQueue.filter(x => !x.processed);
            return [];
        },

        PrintFreightDocs() {
            //ev.preventDefault();
            api.post('/api/Booking/CreateFreightDocs', this.ids).then(res => {
                if (res.data && !res.data.errMsg) {
                    //var url = `/api/Booking/GetDoc?filekey=${res.data.filekey}`;
                    var url = `${Settings.pdfUrlPrefix}${res.data.filekey}.pdf`;
                    this.currFreightDoc = url;
                    this.currFreightDocFullPath = this.currFreightDoc;
                    this.sFreightDocs = true;
                    return;
                }

                alert('Gick ej att skriva ut fraktsedlar');
            });
        },
        GetFullPath(l) {
            return window.location.origin + l;
        },
        OnAfterActionReady() {
            this.$emit('actionready');
        }
    }
}
</script>